import { reduceSeriesToValue, reduceSeriesToValuePreviousPeriod } from "../lib"

export const topCategoriesMapper = (
  data,
  days,
  service,
  comparisonDate,
  timePeriodMetric
) => {
  return {
    categories: data.current[
      `top_works_with_categories_${timePeriodMetric}`
    ].map(categoryMetric => {
      const dailyCategory = data.worksWithCategories.find(
        cm => cm.category.name === categoryMetric.category.name
      )
      const currentCategoryMetric = categoryMetric.metrics[0]
      const comparisonCategoryMetric =
        dailyCategory.metrics.find(
          metric => metric["metric_date"] === comparisonDate
        ) || {}
      return {
        name: categoryMetric.category.name,
        id: categoryMetric.category.id,
        serviceName: service,
        connectionPercentage:
          currentCategoryMetric[`active_users_${timePeriodMetric}`] /
          data.current[`new_users_${timePeriodMetric}`],
        activeUsers: currentCategoryMetric[`active_users_${timePeriodMetric}`],
        activeUsersLastPeriod:
          comparisonCategoryMetric[`active_users_${timePeriodMetric}`],
        serviceEngagement: reduceSeriesToValue(
          dailyCategory.metrics,
          days,
          "service_engagement_daily"
        ),
        serviceEngagementsLastPeriod: reduceSeriesToValuePreviousPeriod(
          dailyCategory.metrics,
          days,
          "service_engagement_daily"
        ),
        topServices: currentCategoryMetric[
          `top_services_${timePeriodMetric}`
        ].map(service => service.channel),
      }
    }),
  }
}
